import React from 'react';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import dynamic from 'next/dynamic';
import Markdown from '../../markdown';
import { usePathname, useSearchParams } from 'next/navigation';
import { isPdpUrl } from 'helpers/utils/pdpUrlHelper';
// const Markdown = dynamic(() => import('../../organisms/markdown'));
export type ImageWithTextProps = {
  data?: any;
  index?: number;
  totalSections?: number;
};

const ImageWithText = ({ data, index, totalSections }: React.PropsWithChildren<ImageWithTextProps>) => {
  const cmsComponentData = data?.banner_slider?.find((banner: any) => banner) || {};
  // const { banner_desktop_image, banner_heading, banner_description, ctas } = cmsComponentData;
  const path = usePathname();
  const isPDP = isPdpUrl(path);
  const cmsCssClass = data?.additional_css;

  const searchParams = useSearchParams();
    const isFromBim = searchParams.get('fromBim') as string === "true";
  
    if (isFromBim) {
      return null;
    }

  const titleTag = isPDP ? 'p':'h1';
  return (
    <div
      className={` ${
        isPDP &&
        `print:left-unset print:translate-none print:translate-x-non  relative left-full !z-[1] w-screen -translate-x-full print:block print:w-full lg:grid lg:grid-cols-12`
      } `}
    >
      <div
        id="advice-section"
        className={` ${
          isPDP &&
          `flex items-center pb-20 print:col-span-full print:col-start-auto print:py-5 lg:col-span-9 lg:col-start-4 lg:pl-30 lg:pr-48 xl:pl-0 xl:pr-60 2xl:pr-80 xl:py-80 2xl:py-100`
        } ${
          data?.desktop_image_alignment === 'Left'
            ? 'print:!flex-row md:flex-row'
            : 'print:!flex-row-reverse lg:flex-row-reverse'
        } ${data?.mobile_image_alignment === 'Top' ? 'flex-col' : 'flex-col'}`}
      >
        <div
          className={`${cmsCssClass}  flex items-center gap-24 lg:gap-0 ${
            data?.desktop_image_alignment === 'Left' ? 'flex-col lg:flex-row' : 'lg:flex-row-reverse'
          } ${data?.mobile_image_alignment === 'Top' ? 'flex-col' : 'flex-col-reverse'}`}
        >
          <div className={`relative hidden w-full lg:block lg:flex-1 lg:flex-grow `}>
            {cmsComponentData?.banner_desktop_image && (
              <Image
                loading="lazy"
                src={cmsComponentData?.banner_desktop_image?.url}
                alt={cmsComponentData?.image?.description}
                className={`${index === 0 && ''} ${totalSections && index === totalSections - 1 && ''} ${
                  index !== 0 && totalSections && index !== totalSections - 1
                    ? data?.desktop_image_alignment === 'Left'
                      ? 'lg:pl-24 xl:pl-30 2xl:pl-0'
                      : 'lg:pr-24 xl:pr-30 2xl:pr-0'
                    : ''
                }`}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '720px',
                  objectFit: 'cover',
                }}
              />
            )}
          </div>
          <div className="flex-1 flex-grow ">
            <div
              className={`${cmsComponentData?.additional_css}  ${isPDP ? ''
                : `2xl:px:80 lg:px-48 xl:px-60
                ${index !== 0 && totalSections && index !== totalSections - 1
                  ? data?.desktop_image_alignment === 'Left'
                    ? 'px-24 lg:pr-24 xl:pr-30 2xl:px-0 2xl:pl-144'
                    : 'px-24 lg:pl-24 xl:pl-30 2xl:px-0 2xl:pr-144'
                  : 'px-24 md:px-48 2xl:pl-64 2xl:pr-144 3xl:pl-80'
              }`}`} 
            >
              <div className="">
                {cmsComponentData?.banner_heading && (
                  <Typography
                    as={titleTag}
                    className=" relative pb-20 pt-50 text-center text-32 font-medium leading-10 text-[#090909] md:m-auto  md:w-[50%] lg:m-0 lg:w-[90%] lg:pt-50 lg:!text-left lg:leading-[2.75rem] xl:m-0 xl:pt-0  xl:!text-left 2xl:m-0 2xl:pt-0 2xl:!text-left 2xl:text-40"
                  >
                    {cmsComponentData?.banner_heading}
                  </Typography>
                )}
              </div>
              {cmsComponentData?.banner_description && (
                <div className="flex justify-center text-[1rem] font-normal leading-8 text-[#333] lg:px-0   xl:gap-12 2xl:gap-16 2xl:text-[1.25rem]">
                  <p className="text-center lg:!text-left xl:!text-left 2xl:!text-left">
                    {cmsComponentData?.banner_description}
                  </p>
                </div>
              )}
              {cmsComponentData?.ctas &&
                cmsComponentData?.ctas.map((cta: any, index: number) => (
                  <div className="flex justify-center lg:justify-start" key={index}>
                    <Link
                      className={` m-0 lg:px-0`}
                      link={cta?.button?.href}
                      target={cta?.button?.href?.includes('https://') ? '_blank' : ''}
                      rel="noopener noreferrer"
                    >
                      <Button
                        style={{
                          backgroundColor: cta?.button_background_color?.hex,
                          border: `1px solid ${cta?.button_border_color?.hex}`,
                          color: cta?.button_text_color?.hex,
                        }}
                        className="relative mb-32 mt-32   w-full overflow-hidden rounded-md rounded-none border-gray-700
                   bg-gray-700 px-24 py-12 py-18 text-14 font-medium
                    leading-4 text-neutral-100 shadow-sm outline-offset-0 
                    transition hover:!bg-[#394A54] hover:bg-gray-500 focus-visible:border focus-visible:outline 
                    focus-visible:outline-offset-[3px] focus-visible:outline-gray-700  active:bg-secondary-black active:shadow-button  disabled:bg-neutral-400 disabled:text-neutral-100 active:disabled:shadow-none  md:max-w-fit md:px-32 lg:mt-48 "
                      >
                        <Typography as="span" className=" text-16 font-medium leading-6 xl:text-14 2xl:text-16">
                          {cta?.button?.title}
                        </Typography>
                      </Button>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ImageWithText;
